<template>
  <label class="tw-font-sans tw-text-sf-gray-darker tw-text-sm tw-mb-1">
    <slot></slot>
  </label>
</template>
